var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSafety(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0679 2.86492L14.5405 0.00234378C14.5405 0.00234378 11.6209 2.60393 8.53354 0C5.44596 2.60398 2.52658 0.00234378 2.52658 0.00234378L0 2.86492C0 2.86492 2.01099 4.21335 0.844534 7.40009C-0.477337 11.0071 -0.844514 16.2218 8.53348 20C17.9116 16.2218 17.5444 11.0071 16.2224 7.40009C15.0568 4.21331 17.0677 2.86492 17.0677 2.86492H17.0679ZM7.86174 13.5382C7.64457 13.7554 7.36019 13.864 7.07581 13.864C6.79143 13.864 6.50705 13.7554 6.28988 13.5382L3.3751 10.6227L4.94618 9.05158L7.07577 11.1812L12.1211 6.1358L13.6922 7.70689L7.86174 13.5382Z",
    fill: "#2E84FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafety);
export default __webpack_public_path__ + "static/media/safety.38702706e925e2a78f7a918dadb5c47b.svg";
export { ForwardRef as ReactComponent };